import { Page } from "../classes/Page";
import { SearchService } from '../services/SearchService';

export class SearchComponent {

  _searchWrapperElements;
  _searchInputEl;
  _results;
  _resultsWrapperContainerEl;

  constructor() {
    this._searchService = new SearchService();
  }

  init() {
    this._searchWrapperElements = document.querySelectorAll('.search-wrapper');
    this._resultsWrapperContainerEl = document.querySelector('.search-wrapper__inner__list');
    const _searchWrapperContainerInnerEl = document.querySelector('.search-wrapper__inner');
    _searchWrapperContainerInnerEl.addEventListener('focusout', ()=>{
      const loader = _searchWrapperContainerInnerEl.querySelector('.loader-wrapper');
      if (loader) loader.remove();
    });

    if (this._searchWrapperElements.length > 0) {
      this.afterComponentRender();
    }
  }

  afterComponentRender() {
    this._searchWrapperElements.forEach(x => {
      const searchFormEl = x.querySelector('form');
      const searchInputEl = searchFormEl.querySelector('input[type="search"]');

      searchFormEl.addEventListener('submit', (e) => {
        e.preventDefault();
        window.location = `${ document.location.origin }/${ Page.getLanguage() }/search/?s=${ searchInputEl.value }`;
      });

      searchInputEl.addEventListener('keyup', this.debounce(function() {
        this.apiCall(searchInputEl)}, 300));

    });
  }

  debounce(func, timeout = 300){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }

  apiCall(inputEl) {
    const loaderEl = document.createElement('div');
    loaderEl.classList.add('position-relative', 'loader-wrapper', 'loader--center');
    loaderEl.innerHTML = `<div class="loader loader--md"></div>`;
    this._resultsWrapperContainerEl.innerHTML = '';
    if (inputEl.value === '') return;

    this._resultsWrapperContainerEl.appendChild(loaderEl);
    this._resultsWrapperContainerEl.classList.add('d-block');
    this._results = [];


    this._searchService.search(Page.getLanguage(), inputEl.value).then(res => {
      this._results = res.data.slice(0, 3);
    }).catch(() => {
      this._results = [];
    }).finally(() => {
      this.showResults();
      loaderEl.remove();
    });
  }

  processChange(inputEl) {
    this.debounce(() => this.apiCall())(inputEl);
  }

  showResults() {
    if (this._results.length > 0) {
      this._resultsWrapperContainerEl.innerHTML = this._results.map(x => {
        return `
            <a href=${ x.url } target="_blank" class="text-nowrap">
              <div class="search-result-item">
                <strong>${ x.title || '' }</strong>
                <i class="icon-arrow_right_icon"></i>
              </div>
            </a>
          `;
      }).join('');

    } else {
      this._resultsWrapperContainerEl.innerHTML = '';
      const noResultsEl = document.createElement('div');

      noResultsEl.classList.add('no-results');
      noResultsEl.innerHTML = `
          <strong>${ this._pageLang === 'de' ? 'Keine Suchergebnisse' : this._pageLang === 'pl' ? 'Brak wyników wyszukiwania' : 'No search results' }</strong>`;
      this._resultsWrapperContainerEl.appendChild(noResultsEl);
    }
  }

}
